import React from 'react'
import { object } from 'prop-types'
import styles from './UserPaymentsPage.styl'

import SubscriptionDetails from '../../components/SubscriptionDetails/SubscriptionDetails'
import { withContext } from '../../../utils/withContext'

class UserPaymentsPage extends React.Component {

	static propTypes = {
		athlete: object,
		context: object
	}

	static getDerivedStateFromProps(nextProps) {
		const { athlete } = nextProps
		return { openState: new Array(((athlete || {}).subscriptions || 1)).fill(false) }
	}

	renderSubscriptions(subscriptions) {
		return subscriptions.map((subscription, index) => <SubscriptionDetails key={ index } subscription={ subscription } />)
	}

	render() {
		const { athlete: { subscriptions }, context: { i18n } } = this.props
		return (
			<div>
				<div className={ styles['content'] }>
					<h2 className={ styles['title'] }>{ i18n`subscription_label` }</h2>
					<ul className={ styles['payment-list'] }>
						{ this.renderSubscriptions(subscriptions) }
					</ul>
				</div>
			</div>
		)
	}
}

export default withContext(UserPaymentsPage)



// WEBPACK FOOTER //
// ./src/client/webapp/pages/UserPaymentsPage/UserPaymentsPage.js